// custom.js
jQuery(document).ready(function () {
  jQuery(".product-carousel").owlCarousel({
    loop: false,
    margin: 30,
    nav: true,
    items: 3,
     dots: false,
    autoplay: false,
    autoplayTimeout: 3000,
        navText: [
      '<img class="custom-prev" src="https://cdn.shopify.com/s/files/1/0557/1667/5686/files/left-arrow.svg?v=1732199399">',
      '<img class="custom-next" src="https://cdn.shopify.com/s/files/1/0557/1667/5686/files/right-arrow.svg?v=1732199398">',
    ],
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
      1200: {
        items: 3,
      },
    },
  });
});

jQuery(document).ready(function () {
  jQuery(".before-after-carousel").owlCarousel({
    loop: false,
    margin: 30,
    nav: true,
    items: 1,
    dots: false,
    autoplay: false,
    autoplayTimeout: 3000,
    navText: [
      '<img class="custom-prev" src="https://cdn.shopify.com/s/files/1/0557/1667/5686/files/left-arrow.svg?v=1732199399">',
      '<img class="custom-next" src="https://cdn.shopify.com/s/files/1/0557/1667/5686/files/right-arrow.svg?v=1732199398">',
    ],
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 1,
      },
      1200: {
        items: 1,
      },
    },
  });
});

jQuery(document).ready(function () {
  jQuery(".formula-carousel").owlCarousel({
    items: 1, // Number of items to show
    margin: 30, // Space between items
    loop: true, // Infinite loop
    autoplay: true, // Enable autoplay
    autoplayTimeout: 5000, // Autoplay interval
     smartSpeed: 800,
    nav: false, // Navigation arrows
    dots: true, // Pagination dots
    navText: [
      '<span class="custom-prev">&lt;</span>',
      '<span class="custom-next">&gt;</span>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  });
});



document.addEventListener("DOMContentLoaded", function () {
  const playIcon = document.getElementById("founder-play__icon");
  const thumbnail = document.getElementById("founder-story__thumbnail");
  const video = document.getElementById("founder-story__video");

  playIcon.addEventListener("click", function () {
    thumbnail.style.display = "none"; // Hide the thumbnail
    playIcon.style.display = "none"; // Hide the play icon
    video.classList.remove("hidden"); // Show the video
    video.play(); // Play the video
  });
});
document.addEventListener('DOMContentLoaded', function () {
  const faqItems = document.querySelectorAll('.faq-item');

  faqItems.forEach((item) => {
    const question = item.querySelector('.faq-question');
    const toggleIcon = item.querySelector('.faq-toggle'); // Select the toggle icon

    question.addEventListener('click', () => {
      item.classList.toggle('active');
      
      // Toggle the icon between + and −
      if (item.classList.contains('active')) {
        toggleIcon.textContent = '−'; // Minus symbol when expanded
      } else {
        toggleIcon.textContent = '+'; // Plus symbol when collapsed
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const faqAnswers = document.querySelectorAll('.faq-answer');

  faqAnswers.forEach((answer) => {
    const paragraphTags = answer.querySelectorAll('p');
    paragraphTags.forEach((p) => {
      if (!p.innerHTML.trim()) {
        p.remove();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const playButtons = document.querySelectorAll('.play-icon'); // Select all play icons

  playButtons.forEach((button) => {
    button.addEventListener('click', function() {
      const id = button.getAttribute('data-attribute-id'); // Get the ID from the data-attribute-id
      const video = document.getElementById('productVideo' + id); // Get the video element by ID
      const thumbnail = document.getElementById('productThumbnail' + id); // Get the thumbnail element by ID
      const playIcon = button; // The play icon itself

      // Hide the thumbnail and play icon, and show the video
      thumbnail.classList.add('hidden');
      playIcon.classList.add('hidden');
      video.classList.remove('hidden');

      // Play the video
      video.play();
    });
  });
});



document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('form'); // Replace 'form' with your form's selector
  const popup = document.getElementById('thank-you-popup');
  const closePopupBtn = document.getElementById('close-popup-btn');
  const popupCloseIcon = document.getElementById('popup-close__icon');

  if (form && popup) {
    form.addEventListener('submit', (event) => {
      event.preventDefault(); // Prevent actual form submission for demonstration
      popup.classList.remove('hidden'); // Show the popup
    });


closePopupBtn.addEventListener('click', () => {

  popup.classList.add = 'hidden'; // Hide the popup
      //  window.location.href = 'https://ochre-us.com/pages/pre-launch'; // Redirect

});
    popupCloseIcon.addEventListener('click', () => {

  popup.classList.add = 'hidden'; // Hide the popup
            window.location.href = 'https://ochre-us.com/pages/pre-launch'; // Redirect

});
  }
});


    